<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <foodora_general_tab :location="location"></foodora_general_tab>
        </template>

    </base_location_modal>
</template>

<script>

import base_location_modal from "../../base/location_modal/base_location_modal";
import foodora_general_tab from "./tabs/foodora_general_tab";



export default {
    name: "foodora_location_modal",
    components : {
        base_location_modal,
        foodora_general_tab,
    },
    data () {
        return {
            tabs_add: [

            ]
        }
    },
}
</script>

<style scoped>

</style>
